<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card>
          <validation-observer ref="refFormObserver">
            <b-form>
              <b-row>
                <b-col cols="12" md="6">
                  <b-form-group label="کد کوپن" label-for="code">
                    <validation-provider #default="{ errors }" rules="required">
                      <b-form-input
                          id="code"
                          v-model="defaultData.code"
                          :state="errors.length > 0 ? false : null"
                      />
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                  <b-form-group label="نوع کوپن" label-for="type">
                    <validation-provider #default="{ errors }" rules="required">
                      <v-select
                          v-model="defaultData.type"
                          :options="typeOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="type"
                          :state="errors.length > 0 ? false : null"
                      />
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col v-if="defaultData.type !== 0" cols="12" md="6">
                  <b-form-group label="ارزش" label-for="couponValue">
                    <validation-provider #default="{ errors }" rules="required">
                      <b-form-input
                          id="couponValue"
                          v-model="defaultData.couponValue"
                          :state="errors.length > 0 ? false : null"
                      />
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                  <b-form-group label="محصول" label-for="productId">
                    <validation-provider #default="{ errors }" rules="required">
                      <b-input-group>
                        <b-form-input
                            id="productId"
                            v-model="selectedProductTitle"
                            :state="errors.length > 0 ? false : null"
                            readonly
                            placeholder="انتخاب محصول"
                        />
                        <b-input-group-append>
                          <b-button variant="outline-primary" @click="openProductModal">
                            انتخاب
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <div v-if="selectedProductTitle" class="mt-1 text-muted small">
                        <feather-icon icon="CheckCircleIcon" size="14" class="text-success mr-50" />
                        محصول انتخاب شده: {{ selectedProductTitle }}
                      </div>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                  <b-form-group label="تاریخ و زمان شروع" label-for="">
                    <validation-provider #default="{ errors }" rules="required">
                      <input
                          type="text"
                          id="start"
                          placeholder="شروع"
                          v-model.trim="defaultData.startDate"
                          :state="errors.length > 0 ? false : null"
                          class="form-control form-control-lg w-11/12 2xl:h-12 h-10 mx-auto mt-1 mb-1 text-sm block w-full rounded-full text-center bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0 placeholder-inputPlaceHolder text-gray-700"
                      />
                    </validation-provider>
                    <custom-date-picker
                        v-model="defaultData.startDate"
                        auto-submit
                        format="YYYY-MM-DD HH:mm"
                        display-format="jYYYY/jMM/jDD HH:mm"
                        class=""
                        element="start"
                        type="datetime"
                        color="#5c6bc0"
                        :min="today"
                    />
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                  <b-form-group label="تاریخ و زمان پایان" label-for="">
                    <validation-provider #default="{ errors }" rules="required">
                      <input
                          type="text"
                          id="end"
                          placeholder="پایان"
                          v-model.trim="defaultData.endDate"
                          :state="errors.length > 0 ? false : null"
                          class="form-control form-control-lg w-11/12 2xl:h-12 h-10 mx-auto mt-1 mb-1 text-sm block w-full rounded-full text-center bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0 placeholder-inputPlaceHolder text-gray-700"
                      />
                    </validation-provider>
                    <custom-date-picker
                        v-model="defaultData.endDate"
                        auto-submit
                        format="YYYY-MM-DD HH:mm"
                        display-format="jYYYY/jMM/jDD HH:mm"
                        class=""
                        element="end"
                        type="datetime"
                        color="#5c6bc0"
                        :min="today"
                    />
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                  <b-form-group label="نوع اجرا" label-for="execution">
                    <validation-provider #default="{ errors }" rules="required">
                      <v-select
                          v-model="defaultData.execution"
                          :options="executionOptions"
                          :reduce="val => val.value"
                          :clearable="false"
                          input-id="execution"
                          :state="errors.length > 0 ? false : null"
                      />
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col v-if="defaultData.execution === 1" cols="12" md="6">
                  <b-form-group label="تعداد کل" label-for="baseQuantity">
                    <validation-provider #default="{ errors }" rules="required">
                      <b-form-input
                          id="baseQuantity"
                          :state="errors.length > 0 ? false : null"
                          v-model="defaultData.baseQuantity"
                      />
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col v-if="defaultData.execution === 1" cols="12" md="6">
                  <b-form-group label="تعداد باقی مانده" label-for="maintainedQuantity">
                    <validation-provider #default="{ errors }" rules="required">
                      <b-form-input
                          id="maintainedQuantity"
                          :state="errors.length > 0 ? false : null"
                          v-model="defaultData.maintainedQuantity"
                      />
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col v-if="defaultData.execution === 2" cols="12" md="6">
                  <b-form-group label="کاربر" label-for="userId">
                    <validation-provider #default="{ errors }" rules="required">
                      <b-form-select
                          id="userId"
                          v-model="defaultData.userId"
                          :state="errors.length > 0 ? false : null"
                          :options="userOptions"
                      >
                        <template #first>
                          <b-form-select-option :value="null" disabled>
                            انتخاب کاربر
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                      <div v-if="selectedUserName" class="mt-1 text-muted small">
                        <feather-icon icon="UserIcon" size="14" class="text-primary mr-50" />
                        کاربر انتخاب شده: {{ selectedUserName }}
                      </div>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>

          <b-button
              variant="primary"
              class="mt-1 mb-sm-0 mr-0 mr-sm-1 col-12 col-md-2"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              @click="validationForm"
          >
            ثبت
          </b-button>
        </b-card>
      </b-col>
    </b-row>

    <ProductSelectionModal
        ref="productModal"
        title="انتخاب محصول برای کوپن"
        @selected="onProductSelected"
    />
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BInputGroup,
  BInputGroupAppend,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { CouponCreateRequest } from "@/libs/Api/Coupon";
import { UsersGetAllRequest } from "@/libs/Api/Users";
import ProductSelectionModal from "@/views/components/Dialogs/ProductsPicker.vue";

export default {
  name: "CouponAdd",
  title: "ساخت کوپن - پنل ادمین بنفشه باقری",
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormSelect,
    BFormSelectOption,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    ProductSelectionModal,
  },
  data() {
    return {
      required,
      defaultData: {
        isDeleted: false,
        couponId: 0,
        type: 1,
        couponValue: "",
        startDate: "",
        endDate: "",
        productId: "",
        execution: 1,
        baseQuantity: "",
        maintainedQuantity: "",
        userId: null,
        hasUsedByUser: true,
        code: "",
        createDate: this.currentDate,
      },
      typeOptions: [
        { label: "درصد", value: 1 },
        { label: "مبلغ", value: 2 },
      ],
      executionOptions: [
        { label: "عمومی", value: 1 },
        { label: "شخصی", value: 2 },
      ],
      selectedProductTitle: "",
      users: [],
      userOptions: [],
    };
  },
  computed: {
    currentDate() {
      let today = new Date();
      let date =
          today.getFullYear() +
          "-" +
          (today.getMonth() + 1) +
          "-" +
          today.getDate();
      let time =
          today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      return date + " " + time;
    },
    today() {
      return new Date();
    },
    selectedUserName() {
      if (!this.defaultData.userId) return "";
      const user = this.users.find((u) => u.userId === this.defaultData.userId);
      return user ? user.name + " " + user.familyName : "";
    },
  },
  mounted() {
    this.fetchUsers();
  },
  methods: {
    async fetchUsers() {
      const request = new UsersGetAllRequest(this);
      request.setParams({
        pageNumber: 1,
        count: 1000,
        search: "",
        state: "",
        isBlocked: "",
        IsIranin: "",
      });
      await request.fetch(
          (content) => {
            this.users = content?.users || [];
            this.userOptions = this.users.map((u) => ({
              value: u.userId,
              text: u.name + " " + u.familyName + " (" + u.mobile + ")",
            }));
          },
          (error) => {
            console.error("Fetch users error:", error);
          }
      );
    },
    validationForm() {
      this.$refs.refFormObserver.validate().then((success) => {
        if (success) {
          this.createCoupon();
        }
      });
    },
    async createCoupon() {
      let couponCreateRequest = new CouponCreateRequest(this);
      couponCreateRequest.setParams(this.defaultData);
      await couponCreateRequest.fetch(
          (content) => {
            console.log(content);
            this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: "عملیات موفق",
                icon: "CheckIcon",
                variant: "success",
                text: "عملیات انجام شد.",
              },
            });
            this.$router.push({ name: "apps-coupons-list" });
          },
          (error) => {
            console.log(error);
          }
      );
    },
    openProductModal() {
      this.$bvModal.show("product-selection-modal");
    },
    onProductSelected(product) {
      this.defaultData.productId = product.productId;
      this.selectedProductTitle = product.title;
    },
  },
};
</script>

<style scoped></style>